import { render, staticRenderFns } from "./accesses-report-page.vue?vue&type=template&id=de9458d8&scoped=true&"
import script from "./accesses-report-page.vue?vue&type=script&lang=ts&"
export * from "./accesses-report-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9458d8",
  null
  
)

export default component.exports